import { 
    TitleLarge,
    TitleMedium,
    BodyRegular,
} from '@/components/typography';
// Modal handler
import { useNewsletter } from '@/contexts/NewsletterContext'
import { PrimaryButton } from '@/components/buttons';
import { LazyVideo, TextBadge } from '@/components/elements';
import { GenericCard } from '@/components/cards';
import Anim from '@/assets/anim/newsletter.webm';
// Cards images
import IconAuction from '@/assets/img/ui/14.png';
import IconNews from '@/assets/img/ui/15.png';
import IconEducation from '@/assets/img/ui/8.png';

export const Support = () => {
    const { openNewsletter } = useNewsletter();

    return (
        <div className="w-full bg-background">
            {/* Hero Section */}
            <section className="w-full flex justify-center px-4 pb-8 py-16 lg:pt-44 relative">
                {/* Background video wrapper */}
                <div className="w-full h-full absolute top-0 left-0 z-0 pointer-events-none">
                    <LazyVideo
                        src={Anim}
                        className="absolute scale-y-[-1] left-3/4 lg:left-2/3 top-[120%] lg:top-[140%] -translate-x-1/2 -translate-y-1/2 min-w-[841px] min-h-[474px] lg:w-[2158px] lg:h-[1214px] rotate-180"
                    />
                </div>

                {/* Glow effects */}
                <div className="absolute left-1/4 top-1/4 w-[481px] h-[481px] lg:w-[605px] lg:h-[605px] opacity-60 bg-primary rounded-full blur-[282.13px] pointer-events-none z-10" />
                <div className="absolute right-1/4 bottom-1/4 w-96 h-96 opacity-60 bg-cyan-400 rounded-full blur-[282.13px] pointer-events-none z-10" />

                {/* Hero content */}
                <div className="w-full max-w-[320px] lg:max-w-[1200px] flex flex-col items-start gap-8 lg:gap-12 relative z-20">
                    <div className="w-full lg:max-w-[716px] flex flex-col items-start gap-4 lg:gap-6">
                        <TextBadge>Support</TextBadge>
                        <TitleLarge className="text-white">
                            Stay <span className="text-primary">Informed</span>, Stay <span className="text-primary">Entertained</span>.
                        </TitleLarge>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="w-full flex justify-center px-4 py-8 lg:py-16 relative z-20">
                <div className="w-full max-w-[320px] lg:max-w-[1200px] flex flex-col items-start gap-6 lg:gap-12">
                    <div className="flex flex-col gap-6">
                        <TitleMedium className="text-white">
                            Newsletter <span className="text-primary">Benefits</span>
                        </TitleMedium>
                        <BodyRegular className="text-white/80 lg:text-white/60 max-w-[320px] lg:max-w-[633px]">
                            Subscribe to receive exclusive updates on auctions, collaborations, and educational content delivered straight to your inbox.
                        </BodyRegular>
                    </div>

                    <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-6">
                        <GenericCard
                            image={IconAuction}
                            title="Weekly AI auction recaps & meme market blogs"
                            titleClassName="max-w-[240px] lg:max-w-none"
                        />
                        <GenericCard
                            image={IconNews}
                            title="News on anime collaborations and creator campaigns"
                            titleClassName="max-w-[240px] lg:max-w-none"
                        />
                        <GenericCard
                            image={IconEducation}
                            title="Educational content on staking, NFTs, and blockchain literacy"
                            titleClassName="max-w-[288px] lg:max-w-none"
                            imageClass='w-28 h-28 -mt-12 -mb-4 lg:-mb-8 lg:w-44 lg:h-44'
                        />
                    </div>

                    <PrimaryButton
                        className="w-full lg:w-96"
                        onClick={openNewsletter}
                    >
                        Subscribe for Updates
                    </PrimaryButton>
                </div>
            </section>
        </div>
    );
};